import * as actions from "./actions";
import * as mutations from "./mutation";
import * as getters from "./getters";
import { state } from "./state";

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
